// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER
// =RESPONSIVE VIDEO!



//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

// *** IntersectionObserver ***

// const elements = document.querySelectorAll(".msdw-animate");

// function check(entries) {
//   entries.map((entry) => {
//     if (entry.isIntersecting) {
//       entry.target.classList.add("msdw-animated");
//       observer.unobserve(entry.target);
//     }
//   });
// }

// const observer = new IntersectionObserver(check);

// elements.forEach((elem) => observer.observe(elem));


//
// =SLIDER (SLICK JS)
// --------------------------------------------------

// tab content
$('.msdw-slider').slick({
  asNavFor: '.msdw-slider-nav',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  adaptiveHeight: true,
  swipe: false,
});

// tab navigation
$('.msdw-slider-nav').slick({
  asNavFor: '.msdw-slider',
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  centerMode: true,
  swipe: true,
  dots: false,
  focusOnSelect: true,
  mobileFirst: true,
  arrows: false,
  variableWidth: false,
  responsive: [
    {
      breakpoint: 599, // 600
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '150px',
        variableWidth: false,
        infinite: true
      }
    },
    {
      breakpoint: 899, // 900
      settings: {
        slidesToShow: 4,
        centerMode: false,
        centerPadding: '0px',
        variableWidth: false,
        infinite: false,
        swipe: false,
      }
    },
  ]
});


//
// =MODAL
// --------------------------------------------------

const modal = document.querySelector('.msdw-dialog');
const modalOpenLinks = document.querySelectorAll('.msdw-modal-open');
const modalClose = document.getElementById('modalClose');

modalOpenLinks.forEach(el => {
  el.addEventListener('click', () => {
    modal.showModal();
    document.body.classList.add('jws-overflowYHidden');
  });
});

modalClose.addEventListener('click', () => {
  modal.close()
  document.body.classList.remove('jws-overflowYHidden');
});

window.addEventListener('click', (event) => {
  if (event.target == modal) {
    modal.close();
    document.body.classList.remove('jws-overflowYHidden');
  }
});


//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

const vid = document.getElementById('msdw-video-responsive');

function loadVideo() {
  var sm = window.matchMedia( "(min-width: 0px) and (max-width: 599px)" ), // Standard def (mp4, 640x360)
      md = window.matchMedia( "(min-width: 600px) and (max-width: 899px)" ), // Standard def (mp4, 960x540)
      lg = window.matchMedia( "(min-width: 900px) and (max-width: 1199px)" ), // High def (mp4, 1280x720)
      xl = window.matchMedia( "(min-width: 1200px) and (max-width: 99999px)" ); // High def 1080 (mp4, 1920x1080)

  sm.addEventListener("change", changeVideoSize);
  md.addEventListener("change", changeVideoSize);
  lg.addEventListener("change", changeVideoSize);
  xl.addEventListener("change", changeVideoSize);

  if      (sm.matches) { changeVideoSize('sm') }
  else if (md.matches) { changeVideoSize('md') }
  else if (lg.matches) { changeVideoSize('lg') }
  else if (xl.matches) { changeVideoSize('xl') }
}

function changeVideoSize(size){
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-"+size));
  vid.autoplay = true;
  vid.load();
  // console.log(videoSource.attr("src"));
}

if (document.contains(vid)) {
  document.addEventListener('DOMContentLoaded', loadVideo);
  window.onresize = loadVideo;
  vid.onloadeddata = () => vid.classList.add('msdw-video-loaded');
}
